import { useEffect, useState, useCallback } from "react";
import { Order } from "src/shared/services/interfacev2";
import { getOrder } from "src/shared/services/servicesv2";

export const useOrderDetails = (id?: string) => {
  const [order, setOrder] = useState<Order | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // ✅ Reusable fetch function
  const fetchOrder = useCallback(async () => {
    if (!id) return;

    try {
      setLoading(true);

      const response = await getOrder(id);

      setOrder(response.data.result || response.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch order details");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOrder();
  }, [fetchOrder]);

  return {
    order,
    setOrder,
    loading,
    error,
    refetchOrder: fetchOrder,
  };
};
